import type { Prototype } from "../prototype-types";

export const vaibhavSinghPrototypes: Prototype[] = [
  {
    id: "vsi-customizable-products-brand-fulfillment",
    name: "Customizable Products M2 — Brand fulfillment",
    path: "/vsi/customizable-products-brand-fulfillment",
    description:
      "Brand-side order surfaces comparing Before (first answer only), PR as built (#86636 order views + #86682 documents), and Proposed layouts across order page, edit/split order, packing slip, pick list, invoice, and new-order email.",
    owner: "Vaibhav Singh",
    createdAt: "2026-09-28",
    lastUpdated: "2026-09-28",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "/images/thumbnails/vsi-customizable-products-brand-fulfillment.png",
  },
  {
    id: "vsi-customizable-products-m-2",
    name: "Customizable Products M2",
    path: "/vsi/customizable-products-m-2",
    description:
      "Customizable Products M2 — PDP, cart, checkout, and brand fulfillment. Current TEXT 1:1 vs Slate M2 (LIST/IMAGE/multi-field).",
    owner: "Vaibhav Singh",
    createdAt: "2026-09-04",
    lastUpdated: "2026-09-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/vsi-customizable-products-m-2.png",
  },
  {
    id: "vsi-pdp-customization-options",
    name: "PDP customization options",
    path: "/vsi/pdp-customization-options",
    description:
      "Retailer PDP and Quick Add with five customization fields: inline expansion vs pop-up, for optional and required customization. Copy from the customization wireframes and the parked pop-up PRs.",
    owner: "Vaibhav Singh",
    createdAt: "2026-10-09",
    lastUpdated: "2026-10-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    project: "Customizable Products",
    thumbnail: "/images/thumbnails/vsi-pdp-customization-options.png",
  },
];
